"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { LanguageModal } from "@/shared/ui/templates";
import { Typography, Icon } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import useUIStore from "@/shared/stores/ui/store";
import { usePathname } from "next/navigation";
import { Language } from "@/shared/types/type/language";
import { useTranslations } from "next-intl";
const HeaderLanguageButton = () => {
  const $ = _c(19);
  const t = useTranslations();
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const {
    setLanguage
  } = useUIStore();
  const language = usePathname()?.split("/")[1] as Language;
  let t0;
  let t1;
  if ($[0] !== language || $[1] !== setLanguage) {
    t0 = () => {
      setLanguage(language);
    };
    t1 = [language, setLanguage];
    $[0] = language;
    $[1] = setLanguage;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsLanguageModalOpen(true);
    };
    t3 = <Icon src="/icons/global.svg" alt="global icon" width={22} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("language");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Typography size={16} lineHeight={22} className="ml-1 text-gray-500">{t4}</Typography>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon src="/icons/arrow.svg" alt="arrow down icon" width={16} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <CustomButton className="flex items-center px-2 py-[6px] bg-gray-200 rounded-lg" onClick={t2}>{t3}{t5}{t6}</CustomButton>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsLanguageModalOpen(false);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isLanguageModalOpen) {
    t9 = <LanguageModal open={isLanguageModalOpen} onClose={t8} />;
    $[14] = isLanguageModalOpen;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <>{t7}{t9}</>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default HeaderLanguageButton;